import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'countryFlagApi',
  standalone: false
})
export class CountryFlagApiPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
